import { IJobPriceDifferentials } from '@medely/types';

export const isHolidayDifferential = (differential: IJobPriceDifferentials): boolean =>
  differential.slug === 'holiday' && differential.recommendation_used;
